import { styled } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

export const ListRelatedRoot = styled(Box)(({ theme }) => ({
  lineHeight: 1.5,
  '& a': {
    textDecoration: 'none',
    boxShadow: `0 2px 0 ${theme.palette.primary.main}`,
    color: theme.palette.grey[600],
    '&:hover': {
      backgroundColor: 'rgba(171,	145,	87, 0.25)',
      boxShadow: 'none',
      color: theme.palette.primary.dark,
    },
  },
}))
